export default function Loader({ label = "Loading" }) {
  return (
    <main className="loading-page" data-testid="loading-state">
      <div className="pulse-bars" aria-hidden="true"><span /><span /><span /></div>
      <p data-testid="loading-state-label">{label}</p>
    </main>
  );
}